import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { IconSize } from '../IconWrap';
import s from './CircleWrap.scss';
var CircleWrap = function (_a) {
    var _b = _a.size, size = _b === void 0 ? IconSize.MEDIUM : _b, circleClassName = _a.circleClassName, children = _a.children, props = __rest(_a, ["size", "circleClassName", "children"]);
    return (React.createElement("span", { className: classnames(s['disc'], s[size], circleClassName) }, children));
};
CircleWrap.displayName = 'CircleWrap';
export default CircleWrap;
//# sourceMappingURL=CircleWrap.js.map